const { $document, $window } = require('../lib/selectors');

// require hammer js so users can swipe pop-up at mobile
require('hammerjs');

// include featherlight for pop-up images
require('featherlight');

// include gallery feature of featherlight
require('featherlight/src/featherlight.gallery');

const throttle = require('lodash.throttle');

// how tall the image should ever be including the legend
const MAX_HEIGHT = 0.95;
let SHADOWBOX_OPEN = false;

initFeatherlight();
$window.resize(throttle(resizeOpenedShadowbox, 250));
$document.ajaxComplete(() => {
  initFeatherlight();
});

function initFeatherlight() {
  if ($('.shadowbox').length) {
    $('.shadowbox').featherlightGallery({
      previousIcon: '<span class="icon-chevron-thin-left"></span>',
      nextIcon: '<span class="icon-chevron-thin-right"></span>',
      closeIcon: '<span title="close" class="icon-close"></span>',

      beforeOpen: () => {
        $('body').addClass('shadowBoxOpen');
      },

      afterClose: () => {
        $('body').removeClass('shadowBoxOpen');
      },
    });
  }
}


function setImageSize() {
  const windowHeight = window.innerHeight;
  const legendHeight = $('.legend').outerHeight(true);
  const allowHeight = (windowHeight - legendHeight) * MAX_HEIGHT;
  const vh = allowHeight / windowHeight * 100;
  $('.featherlight-image').css('max-height', `${vh}vh`);
}

function resizeOpenedShadowbox() {
  if (SHADOWBOX_OPEN) {
    setImageSize();
  }
}

